import React, { useState } from 'react';
import ModalWrapper from '../Modal/ModalWrapper';
import TermsOfService from '../TermsNPrivacy/TermsOfService';
import PrivacyPolicy from '../TermsNPrivacy/PrivacyPolicy';
import { useTranslation } from 'react-i18next';

const TermsPrivacyWrapper = () => {
  const [isRender, setIsRender] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedContent, setSelectedContent] = useState(null);
  const { t } = useTranslation();

  const openModal = (content) => {
    setIsRender(true);
    setSelectedContent(content);
    setTimeout(() => {
      setIsOpen(true);
    }, 50);
  };

  return (
    <>
      <div className='footer-terms-privacy-wrapper'>
        <button
          type={'button'}
          className={'button-default footer-quick-button type-divide'}
          onClick={() => {
            openModal('terms');
          }}
        >
          {t('terms_of_service').toUpperCase()}
        </button>
        <button
          type={'button'}
          className={'button-default footer-quick-button type-bold-button type-divide'}
          onClick={() => {
            openModal('privacy');
          }}
        >
          {t('privacy_policy').toUpperCase()}
        </button>
        <a
          href='https://vlending.notion.site/F-a-n-E-v-e-n-t-d55fc4f8e6e44c0ebe093d27aedc66c5'
          target='_blank'
          className={'button-default footer-quick-button type-bold-button'}
          rel='noreferrer'
        >
          {t('biz_inquiries').toUpperCase()}
        </a>
      </div>
      {isRender ? (
        <ModalWrapper
          isOpen={isOpen}
          onClose={() => {
            setIsOpen(false);
            setIsRender(false);
          }}
        >
          {selectedContent === 'terms' ? <TermsOfService /> : null}
          {selectedContent === 'privacy' ? <PrivacyPolicy /> : null}
        </ModalWrapper>
      ) : null}
    </>
  );
};

export default TermsPrivacyWrapper;
